import React from 'react';

function Education() {
  return (
    <section id="education">
      <h2 className="section-title">Education</h2>
      <div className="education-item">
        <h3>Northeastern University</h3>
        <div className="degree">Bachelor of Science in Computer Science</div>
        <div className="detail">Khoury College of Computer Sciences</div>
      </div>
    </section>
  );
}

export default Education;
